export function downloadBase64File(
  base64Data: string,
  fileName: string,
  mimeType: string,
): void {
  const base64 = base64Data.startsWith('data:')
    ? base64Data.split(',')[1]
    : base64Data

  const byteCharacters = atob(base64)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    byteArrays.push(new Uint8Array(byteNumbers))
  }

  const blob = new Blob(byteArrays, { type: mimeType })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName

  link.click()
}

// Download de arquivo devolvido direto pelo back (Content-Disposition: attachment),
// requisitado com responseType 'blob' — sem passar por base64.
export function downloadBlobFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

// Nome do arquivo que o back montou no Content-Disposition (o padrão que a operação
// arquiva). O header só chega se o CORS expuser; sem ele, cai no fallback.
export function fileNameFromContentDisposition(
  header: string | null | undefined,
  fallback: string,
): string {
  if (!header) return fallback
  const utf8 = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header)
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim())
    } catch {
      // cai pro filename simples
    }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header)
  return plain ? plain[1].trim() : fallback
}

// Com responseType 'blob' o corpo do erro (JSON com a mensagem do back) também vira
// Blob — sem ler ele, SnackbarCustomService.errorRequest não acha a mensagem.
export async function parseBlobError(err: any): Promise<any> {
  if (!(err?.error instanceof Blob)) return err
  try {
    const text = await err.error.text()
    try {
      return { ...err, error: JSON.parse(text) }
    } catch {
      return { ...err, error: text }
    }
  } catch {
    return err
  }
}

// export function CleanFileName(text: any) {
//   // let cleanedText = text.toLowerCase()
//   let cleanedText = text
//
//   cleanedText = cleanedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
//
//   cleanedText = cleanedText.replace(/[<>:"/\\|?*,\s;@#$%&()\[\]\{\}]/g, ' ')
//   cleanedText = cleanedText.replace(/--+/g, '-')
//   cleanedText = cleanedText.replace(/^-|-$/g, '')
//
//   return cleanedText
// }

export function CleanFileName(text: any) {
  let cleanedText = String(text)

  cleanedText = cleanedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  cleanedText = cleanedText.replace(/[<>:"/\\|?*,\s;@#$%&()\[\]\{\}.!+_=]/g, ' ')
  cleanedText = cleanedText.replace(/-+/g, ' ')
  cleanedText = cleanedText.replace(/^-|-$/g, '')

  return cleanedText
}

